const getBaseUrl = (index: number) => {
    switch (index) {
        case 1: return 'https://eticketing-api.bohniman.in';
        case 2: return 'https://water-metro-cloud-api.bohniman.in';
        case 3: return 'https://api-watermetro.assam.gov.in';
        default: return 'https://eticketing-api.bohniman.in';
    }
}

export const API_ENDPOINT = {
    BASE_URL: getBaseUrl(3),

    DISPLAY_SETTINGS: (displayId: string) => `/api/terminal/settings/${displayId}`,

    TRIPS_BY_ORIGIN: `/api/terminal/get-outgoing-trips`,

};